import React from 'react'

import { IconTitleDescriptionImageItemType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'

import { Description, Image, Title } from './IconTitleDescriptionImageItem.styled'

export const IconTitleDescriptionImageItem = ({
    title,
    description,
    icon,
}: IconTitleDescriptionImageItemType): JSX.Element => {
    return (
        <Grid container alignItems="start">
            <Grid item xs={2}>
                {icon && <Image image={icon} />}
            </Grid>
            <Grid item xs={10}>
                <Title>{title}</Title>
                {description && <Description>{description}</Description>}
            </Grid>
        </Grid>
    )
}
